import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { racineConfig } from "./data";

export default function RacineWIPage() {
  return <CityPageTemplate config={racineConfig} />;
}